import React, { useEffect, useMemo, useState } from "react";
import useSWR from "swr";
import classNames from "classnames/bind";

import { CATEGORIES } from "../../api/categories";

import { Screen } from "components/Screen";
import { SearchBox } from "components/SearchBox";

import { useStateManager } from "utils/useStateManager";

import styles from "../../components/DietanamnezTile/DietanamnezTile.module.css";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: (exists?: boolean) => Promise<void>;
  onBack: () => void;
};

export const Supplement: React.FC<Props> = (props) => {
  const { linkInfo, dietanamnezItems, setDietanamnezItem, isLoading, setIsLoading } = useStateManager();

  const { data: allSupplements = [], isValidating } = useSWR<
    {
      key: string;
      custom_наименование: string;
      custom_макс_доз_в_день: number;
      custom_страны:
      | null
      | {
        key: string;
      }[];
      custom_производитель?: {
        key: string;
      };
    }[]
  >([CATEGORIES.SUPPLEMENT, 572]);

  const supplements = allSupplements
    .filter((supplement) => {
      if (!linkInfo?.manufacturers) {
        return true;
      }

      return linkInfo.manufacturers.some(
        (manufacturer) =>
          manufacturer.key === supplement.custom_производитель?.key
      );
    })
    .filter((supplement) => {
      if (!linkInfo?.country) {
        return true;
      }

      if (!supplement.custom_страны) {
        return true;
      }

      return supplement.custom_страны?.some(
        (country) => country.key === linkInfo.country
      );
    });

  const handleChange = (search: string, values: string[]) => {
    return Promise.all([
      values.map((key) => {
        const supplement = supplements.find((item) => item.key === key)!;

        return setDietanamnezItem(key, {
          custom_количество: supplement.custom_макс_доз_в_день * 100,
          custom_частота_употребления: "c105a902t44r1848",
        });
      }),
    ]);
  };

  const handleRemoveItem = (key: string) => {
    setDietanamnezItem(key, undefined);
  };

  const [errorMessage, setErrorMessage] = useState<boolean>(false)

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage(false)
      }, 5000);
    }
  }, [errorMessage]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await props.onSubmit();
    } catch (error) {
      // @ts-ignore
      if (error.message === 'Network Error') {
        setErrorMessage(true);
      }
    }
    setIsLoading(false);
  };

  const options = useMemo(
    () => {
      if (!linkInfo?.country) {
        return supplements.filter((item) => (
          item.custom_страны?.find((country) => (
            country.key === "c105a902t104r5087852"
          ))
        )).map((item) => ({
          value: item.key,
          label: item.custom_наименование,
        }));
      };

      return supplements.map((item) => ({
        value: item.key,
        label: item.custom_наименование,
      }))
    },
    [supplements]
  );
  const value = useMemo(
    () =>
      dietanamnezItems
        .filter((item) => item.custom_блюдо.includes("t157"))
        .map((item) => item.custom_блюдо),
    [dietanamnezItems]
  );

  return (
    <>
      {errorMessage && (
        <div className={cx("notification")}>
          <span>Ошибка подключения сети</span>
          <span className={cx("notification-close")}
            style={{ width: 12, height: 12 }}
            onClick={() => setErrorMessage(false)}
          >
            <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path
              d="M6.3 5l3.3-3.3c.3-.4.3-1 0-1.4C9.4 0 9 0 9 0c-.4 0-.7 0-.8.3L5 3.6 1.6.3C1.5 0 1.2 0 1 0 .7 0 .5 0 .3.3c-.4.4-.4 1 0 1.4L3.5 5 .3 8.2c-.4.4-.4 1 0 1.4.2.2.4.3.7.3l.7-.4L5 6.4l3 3.2c0 .2.4.3.7.3l.6-.4c.3-.4.3-1 0-1.4L6.3 5z"
              fill="currentColor"></path>
            </svg>
          </span>
        </div>
      )}
      <Screen
        title={`Продукция ${linkInfo?.manufacturers?.map((item) => item.label).join(", ") || ""
          }`}
        buttonTitle={value.length === 0 ? "Нет, не употребляю" : "Продолжить"}
        onSubmit={handleSubmit}
        onBack={props.onBack}
        isLoading={isLoading}
      >
        <SearchBox
          title="Вы сейчас употребляете продукцию Amway?"
          placeholder="Введите название продукта"
          isLoading={isValidating}
          options={options}
          onChange={handleChange}
          onRemoveItem={handleRemoveItem}
          minSearchLength={0}
          value={value}
        />
      </Screen>
    </>
  );
};
